import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import {
  AutoComplete,
  Button,
  Checkbox,
  Col,
  Collapse,
  Form,
  Input,
  Row,
  Select,
  Spin,
} from "antd";
import "antd/dist/antd.min.css";
import "../styles/Main.scss";
// import InputField from "../common/htmlComponents/InputField";
import ButtonField from "../common/htmlComponents/ButtonField";
import { getRequest, patchRequest } from "../axios";
// import { ReactComponent as SearchLocation } from "../image/SearchLocation.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../utils/Notifications";
// import { useNavigate } from "react-router-dom";
import { authUserData } from "../utils/Helper";
import { debounce } from "lodash";
import { LoadScript } from "@react-google-maps/api";

const Setting = ({ handleCancel, setReload, modalKey, setStateM }) => {
  const { t } = useTranslation();
  const userId = authUserData()?.user_id;
  const { Option } = Select;
  const formRef = useRef();
  const initialState = {
    // user_id:userId,
    pl_company_address: authUserData()?.pl_company_address,
    pl_company_suburb: authUserData()?.pl_company_suburb,
    pl_company_state: authUserData()?.pl_company_state,
    pl_company_postcode: authUserData()?.pl_company_postcode,
    pl_company_additional_detail: authUserData()?.pl_company_additional_detail,
    country: authUserData()?.country ? authUserData()?.country : 1,
    state: authUserData()?.state ? authUserData()?.state : 1,
    // city:  authUserData()?.city?authUserData()?.city:1,
  };

  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  // const [cities, setCities] = useState([]);
  const [countryName, setCountryName] = useState([]);
  const [states, setStates] = useState([]);
  const [options, setOptions] = useState([]);
  const { Panel } = Collapse;
  // const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [formColumns] = Form.useForm();
  useEffect(() => {
    getCountryName();
    authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
    // authUserData()?.state?
    // getCityByState(authUserData()?.state): getCityByState(1);
  }, []);
  const auth_package_columns = authUserData()?.packages_columns;
  // const navigate = useNavigate();
  const libraries = ["places"];
  // const { isLoaded, loadError } = useLoadScript({
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  //   libraries: ['places'],
  // });
  // Preselect checkboxes based on authData.package_columns
  useEffect(() => {
    console.log("User Columns", auth_package_columns);
    if (auth_package_columns.length !== 0) {
      setSelectedColumns(auth_package_columns);
    }
  }, []);
  useEffect(() => {
    const zoneGetById = async () => {
      if (userId !== null) {
        try {
          const response = await getRequest(`user-detail/${userId}/`);

          if (response.status) {
            const { country, state } = response.data.data;

            // Update the state with the values from the API response
            setState({
              ...initialState, // Retain existing initialState values
              country: country || initialState.country, // Update with API response or fallback to initialState
              state: state || initialState.state,
              // city: city || initialState.city,
            });
          }
        } catch (error) {
          console.error("Error fetching user details:", error);
        } finally {
          // Set loading state to false after fetching data
          setapiLoading(false);
        }
      }
    };
    zoneGetById();
  }, [userId, modalKey]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        // backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleSelect = (value) => {
    const selected = options.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          setState((prevstate) => ({
            ...prevstate,
            pl_company_address: place.formatted_address,
            pl_company_suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            pl_company_state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            pl_company_postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          }));
          form.setFieldsValue({
            pl_company_address: place.formatted_address,
            pl_company_suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            pl_company_state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            pl_company_postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          });
        }
      });
    }
  };

  const handleSearch = useCallback(
    debounce((value) => {
      //  setLoading(true);

      const service = new window.google.maps.places.AutocompleteService();

      if (value !== "") {
        service.getPlacePredictions({ input: value }, (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            setOptions(
              predictions.map((prediction) => ({
                value: prediction.description,
                place_id: prediction.place_id,
              }))
            );
            // setLoading(false);
          } else {
            setOptions([]);
            // setLoading(false);
          }
        });
      } else {
        setOptions([]);
        // setLoading(false);
        setState((prevstate) => ({
          ...prevstate,
          pl_company_address: "",
          pl_company_suburb: "",
          pl_company_state: "",
          pl_company_postcode: "",
        }));
        form.setFieldsValue({
          pl_company_address: "",
          pl_company_suburb: "",
          pl_company_state: "",
          pl_company_postcode: "",
        });
      }
    }, 300),
    []
  );

  // const handleCityChange = (value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     city: value,
  //   }));
  // };
  const handleStateSelectChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      state: value,
      // city:null,
    }));
    // formRef.current.setFieldsValue({ city: null });
    // setCities([]);
    // getCityByState(value);
  };
  // const getCityByState = async (id) => {
  //   const cityResponse = await getRequest(
  //     "city/?no_pagination=true&state_id=" + id
  //   );

  //   setCities(cityResponse?.data?.data);
  // };
  const handleCountrySelectChange = (value) => {
    // getPermissionByCountry(value);
    setState((prevState) => {
      return {
        ...prevState,
        country: value,
        state: null,
      };
    });
    formRef.current.setFieldsValue({ state: null });
    setStates([]);
    getStateByCountry(value);
  };
  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const getCountryName = async (data) => {
    await getRequest("country/?no_pagination=True", data).then((response) => {
      setCountryName(response?.data?.data);
    });
  };

  // const handleInputChange = (e) => {
  //   let { name, value } = e.target;
  //   setState({ ...state, [name]: value.toUpperCase() });
  // };

  // const backToList = () => {
  //   // setState(initialState);
  //   // formRef.current.setFieldsValue(initialState);
  //   // handleCancel();
  // };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;

      response = await patchRequest(`user-detail/${userId}/`, state);
      if (response.data.success) {
        localStorage.setItem("auth_data", JSON.stringify(response?.data.data));
        SuccessNotificationMsg(t("User setting updated successfully"));
        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1,
        }));

        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        handleCancel();
        setReload((reload) => !reload);
      }
    } catch (error) {
      // ErrorNotificationMsg(
      //   zoneId === null
      //     ? t("error_in_adding_zone_name")
      //     : t("error_in_updating_zone_name")
      // );
      setBtnLoading(false);
    }
  };

  // check box column

  // const [checked, setChecked] = useState(false);

  // const handleCheckboxChange = (e) => {
  //   setChecked(e.target.checked);
  // };

  const allColumns = [
    { key: "parcel_no", title: "Parcel Number" },
    { key: "created_at", title: "Schedule Date" },
    { key: "hawb", title: "HAWB" },
    { key: "unrouted", title: "Unrouted" },
    { key: "sequence_no", title: "Sequence" },
    { key: "is_scanned", title: "Is Scanned" },
    { key: "status", title: "Status" },
    { key: "suburb", title: "Suburb" },
    { key: "zone", title: "Zone" },
    { key: "state", title: "State" },
    { key: "postcode", title: "Postcode" },
    { key: "assigned_to", title: "Assigned Driver" },
    { key: "latitude", title: "Latitude" },
    { key: "longitude", title: "Longitude" },
    { key: "customer_code", title: "Customer Code" },
    { key: "customer_name", title: "Customer Name" },
    { key: "company", title: "Company" },
    { key: "customer_phone", title: "Customer Phone" },
    { key: "customer_email", title: "Customer Email" },
    { key: "customer_address", title: "Customer Address" },
    { key: "description_of_goods", title: "Description of Goods" },
    { key: "count", title: "Count" },
    { key: "landed", title: "Landed" },
    { key: "weight", title: "Weight" },
    { key: "shipper_code", title: "Shipper Code" },
    { key: "shipper_name", title: "Shipper Name" },
    { key: "shipper_address", title: "Shipper Address" },
    { key: "shipper_city", title: "Shipper City" },
    { key: "shipper_state", title: "Shipper State" },
    { key: "shipper_postcode", title: "Shipper Postcode" },
    { key: "shipper_country", title: "Shipper Country" },
    { key: "origin", title: "Origin" },
    { key: "port", title: "Port" },
    { key: "total_value", title: "Total Value" },
    { key: "goods_currency", title: "Goods Currency" },
    { key: "sac", title: "SAC" },
    { key: "fr_reference", title: "FR Reference" },
    { key: "sub_master", title: "Sub Master" },
    { key: "pkg_type", title: "Package Type" },
    { key: "cyber_vendor_account", title: "Cyber Vendor Account" },
    { key: "customs_code", title: "Customs Code" },
    { key: "operation", title: "Action" },
  ];
  const [selectedColumns, setSelectedColumns] = useState(["operation"]); // Track selected columns
  // const [apiLoading, setApiLoading] = useState(false); // For loading state

  // Handle checkbox change
  const handleCheckboxChange = (e, columnKey) => {
    if (e.target.checked) {
      setSelectedColumns([...selectedColumns, columnKey]); // Add column to selectedColumns
    } else {
      setSelectedColumns(selectedColumns.filter((key) => key !== columnKey)); // Remove column from selectedColumns
    }
  };

  // Handle form submission
  const handleSubmitColumns = async (values) => {
    console.log("Form Submitted with values:", values);

    // Prepare the payload
    const payload = {
      packages_columns: selectedColumns,
      // Add any other form data here
    };

    console.log("Submitting payload:", payload);

    try {
      // Make API call
      const response = await patchRequest(
        `user-detail/${userId}/update-user-package-field/`,
        payload
      );
      if (response?.data?.success) {
        localStorage.setItem("auth_data", JSON.stringify(response?.data?.data));
        SuccessNotificationMsg(t("User Package Columns updated successfully"));

        // Reset form or state as necessary
      } else {
        console.error("Failed to update data");
      }
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };

  return (
    <>
      <section className="grid-sec FormSection profilepage">
        <div className="FormHeader">
          <h1> {t("Settings")}</h1>
        </div>

        <div className="FormBody">
          <LoadScript
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            libraries={libraries}
          >
            <Spin spinning={apiLoading}>
              <Form
                onFinish={handleSubmit}
                autoComplete="off"
                ref={formRef}
                initialValues={state}
                form={form}
              >
                <Collapse defaultActiveKey={["1", "2", "3", "4", "5"]}>
                  <Panel
                    header="1.Route Start Address"
                    key="1"
                    style={{ textAlign: "left" }}
                  >
                    <Row gutter={[25]}>
                      <Col md={5} className="TextFeild">
                        <Form.Item
                          name="country"
                          label={t("pl_country")}
                          placeholder={t("pl_select_country")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_country")}</Trans>,
                            },
                          ]}
                        >
                          <Select
                            placeholder={t("pl_select_country")}
                            showArrow
                            showSearch
                            // allowClear
                            value={state?.country}
                            // name="country"
                            optionFilterProp="children"
                            onChange={(value) =>
                              handleCountrySelectChange(value)
                            }
                          >
                            {countryName?.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col md={5} className="TextFeild">
                        <Form.Item
                          name="state"
                          label={t("pl_state")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_select_state")}</Trans>,
                            },
                          ]}
                        >
                          <Select
                            name="state"
                            placeholder={t("pl_select_state")}
                            showArrow
                            showSearch
                            // allowClear
                            value={state?.state}
                            optionFilterProp="children"
                            onChange={handleStateSelectChange}
                          >
                            {states.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      {/* <Col md={5} className="TextFeild">
                   
                   <Form.Item
                       name="city"
                       label={t("City")}
                       rules={[
                           {
                               required: true,
                               message: <Trans>{t("Select City")}</Trans>,
                           },
                       ]}
                   >
                       <Select
                           placeholder={t("Select City")}
                           showArrow
                           showSearch
                          //  allowClear
                          //  name="city"
                           value={state?.city}
                           
                  optionFilterProp="children"
                         onChange={handleCityChange}
                       >
                           {cities.map((item) => (
                               <Option key={item.id} value={item.id}>
                                   {item.name}
                               </Option>
                           ))}
                       </Select>
                   </Form.Item>
                
                
                   </Col> */}

                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="pl_company_address"
                          label={t("Street Address")}
                          rules={[
                            {
                              required: true,
                              message: (
                                <Trans>{t("search_company_address")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <AutoComplete
                            id="pl_company_address"
                            placeholder={t("Search Street Address")}
                            options={options}
                            onSearch={handleSearch}
                            onSelect={handleSelect}
                            value={state.pl_company_address}
                            onChange={(value) => {
                              setState((prevstate) => ({
                                ...prevstate,
                                pl_company_address: value,
                              }));
                              form?.setFieldsValue({
                                pl_company_address: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="pl_company_suburb"
                          label={t("Suburb")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_suburb")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("pl_enter_suburb")}
                            name="pl_company_suburb"
                            value={state.pl_company_suburb}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                pl_company_suburb: value,
                              }));
                              form.setFieldsValue({
                                pl_company_suburb: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="pl_company_state"
                          label={t("State")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_state")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("pl_enter_state")}
                            name="pl_company_state"
                            value={state.pl_company_state}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                pl_company_state: value,
                              }));
                              form.setFieldsValue({
                                pl_company_state: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="pl_company_postcode"
                          label={t("Postcode")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_Postcode")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("pl_enter_postcode")}
                            name="pl_company_postcode"
                            value={state.pl_company_postcode}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                pl_company_postcode: value,
                              }));
                              form.setFieldsValue({
                                pl_company_postcode: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={6}
                        xl={6}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="pl_company_additional_detail"
                          label={t("additional_details")}
                          rules={[
                            {
                              required: true,
                              message: (
                                <Trans>{t("pl_enter_additional_detail")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("enter_additional_details")}
                            name="pl_company_additional_detail"
                            value={state.pl_company_additional_detail}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                pl_company_additional_detail: value,
                              }));
                              form.setFieldsValue({
                                pl_company_additional_detail: value,
                              });
                            }}
                            // Adjust the number of rows as needed
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <div
                      className="ModalPopupFooter"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      {/* <ButtonField
                    className="CancelGradiantBtn"
                    type="primary"
                    label={t("cancel")}
                    onClick={backToList}
                    style={{ marginRight: '8px' }} // Space between buttons
                  /> */}
                      <ButtonField
                        className="SaveGradiantBtn"
                        type="primary"
                        label={t("Update")}
                        htmlType="submit"
                        loading={btnLoading}
                      />
                    </div>
                  </Panel>
                </Collapse>
                <Col></Col>
              </Form>
            </Spin>
          </LoadScript>
        </div>
      </section>
      {/* check box column */}
      <section className="grid-sec FormSection profilepage">
        <div className="FormBody">
          <Collapse defaultActiveKey={["1", "2", "3", "4", "5"]}>
            <Panel
              header="2.Package Columns List"
              key="1"
              style={{ textAlign: "left" }}
            >
              <Form form={formColumns} onFinish={handleSubmitColumns}>
                <Row gutter={[16, 16]}>
                  {allColumns.map((column) => (
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={8}
                      xl={6}
                      key={column.key}
                      className="TextField"
                      style={{ display: "flex" }}
                    >
                      <Checkbox
                        checked={selectedColumns.includes(column.key)}
                        disabled={column.key === "operation"}
                        onChange={(e) => handleCheckboxChange(e, column.key)}
                        className="checkbox-item"
                      />
                      <label className="column-label" style={{ marginLeft: 8 }}>
                        {column.title}
                      </label>
                    </Col>
                  ))}
                </Row>

                <div
                  className="ModalPopupFooter"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={apiLoading} // Show loading spinner during API call
                    className="SaveGradiantBtn"
                  >
                    Update
                  </Button>
                </div>
              </Form>
            </Panel>
          </Collapse>
        </div>
      </section>
    </>
  );
};

Setting.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,

  modalKey: PropTypes.bool,
  setStateM: PropTypes.func.isRequired,
};

export default Setting;
